export type UseControlsReducerState = {
  isNotes: boolean
  isSeoMetaTags: boolean
  isWireframeTypes: boolean
  isHeadersSet: boolean
  isLinks: boolean
  isCommaSeparated: boolean
  withoutBlocks?: boolean
}

export enum UseControlsActionTypes {
  SET_NOTES = 'SET_NOTES',
  SET_SEO_META = 'SET_SEO_META',
  SET_WIREFRAMES = 'SET_WIREFRAMES',
  SET_COMMA_SEPARATOR = 'SET_COMMA_SEPARATOR',
  SET_HEADERS = 'SET_HEADERS',
  SET_LINK = 'SET_LINK',
}

export type UseControlsActions =
  | {
      type: UseControlsActionTypes.SET_SEO_META
    }
  | {
      type: UseControlsActionTypes.SET_WIREFRAMES
    }
  | {
      type: UseControlsActionTypes.SET_NOTES
    }
  | {
      type: UseControlsActionTypes.SET_HEADERS
    }
  | {
      type: UseControlsActionTypes.SET_LINK
    }
  | {
      type: UseControlsActionTypes.SET_COMMA_SEPARATOR
    }

export type UseReducerActions = {
  setNotes: () => void
  setSeoMeta: () => void
  setWireframes: () => void
  setCommaSeparator: () => void
  setHeaders: () => void
  setLinks: () => void
}

export type UseControls = {
  actions: UseReducerActions
  state: UseControlsReducerState
}

export interface ParseProjectItem {
  parentId: string
  pageId: string
  pageName: string
  blockTitle: string
  blockContent: string
  pageUrl: string
  seoTitle: string
  seoSlug: string
  seoDescription: string
  seoH1: string
  seoNote: string
  keywords: string
  pageIntent: string
}
